export default "__VITE_ASSET__tHhtTRPU__"